export default __webpack_public_path__ + "static/retail-8717464c20fd4b2c36861c2b5f101400.webp";